import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogImage?: string;
}

export function useSEO(props: SEOProps) {
  const location = useLocation();
  const baseUrl = 'https://www.shenmashipin.com';

  useEffect(() => {
    const {
      title = '神马视频 - 水果视频品牌高清免费在线观看',
      description = '神马视频为您提供香蕉视频、红桃视频、蜜桃视频、樱桃视频等水果视频品牌的高清免费在线观看，电视剧电影全集不缓冲播放。',
      keywords = '香蕉视频,红桃视频,蜜桃视频,樱桃视频,神马视频,免费在线观看,高清不缓冲,电影全集,视频在线观看',
      canonicalUrl = `${baseUrl}${location.pathname}`,
      ogTitle,
      ogDescription,
      ogType = 'website',
      ogImage,
    } = props;

    document.title = title;

    const setMeta = (name: string, content: string, property = false) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    const canonicalEl = document.querySelector('link[rel="canonical"]');
    if (canonicalEl) {
      canonicalEl.setAttribute('href', canonicalUrl);
    }

    setMeta('og:title', ogTitle || title, true);
    setMeta('og:description', ogDescription || description, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('og:locale', 'zh_CN', true);
    if (ogImage) {
      setMeta('og:image', ogImage, true);
    }

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', ogTitle || title);
    setMeta('twitter:description', ogDescription || description);
  }, [location.pathname, props]);
}